import React from 'react';
import mobileImage from '../assets/video/Mobile.svg';

const CoachSection = () => {

  return (
    <section className="bg-gray-50 text-center py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-900 mb-4 sm:mb-6">Meet Your Coach</h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto mb-8 sm:mb-10">
            With years of experience training players at all levels, our passionate 
            coach brings both technical expertise and motivational energy to help you 
            reach your full potential on the court.
          </p>
          
          <div className="mt-8 text-center">
            <img 
              src={mobileImage} 
              alt="Tennis coaching session"
              className="max-w-full h-auto rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.1)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoachSection;
